var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightenImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.438 7.18701C68.438 3.32102 65.304 0.187012 61.438 0.187012L37.7724 0.187012C33.9065 0.187012 30.7724 3.32102 30.7724 7.18701V22.7003C30.7724 26.5663 27.6384 29.7003 23.7725 29.7003H7.50586C3.63987 29.7003 0.505862 32.8343 0.505861 36.7003L0.505859 60.3659C0.505859 64.2319 3.63986 67.3659 7.50585 67.3659H23.7724C27.6384 67.3659 30.7724 70.4999 30.7724 74.3659V90.095C30.7724 93.961 33.9065 97.095 37.7724 97.095H61.438C65.304 97.095 68.438 93.961 68.438 90.095V74.3659C68.438 70.4999 71.572 67.3659 75.438 67.3659H90.4138C94.2798 67.3659 97.4138 64.2319 97.4138 60.3659V36.7003C97.4138 32.8343 94.2798 29.7003 90.4138 29.7003H75.438C71.572 29.7003 68.438 26.5663 68.438 22.7003V7.18701Z",
    fill: "#8ABEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightenImg5);
export default __webpack_public_path__ + "static/media/brighten-img-5.2cdfb51da2136659074e0eb668909ea1.svg";
export { ForwardRef as ReactComponent };